import { StyleProvider } from "@ant-design/cssinjs";
import "@ant-design/v5-patch-for-react-19";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ConfigProvider } from "antd";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { useTheme } from "./hooks/useTheme.ts";
import { getContrastTextColor } from "./lib/utils.ts";
import "./index.css";
import { AppProvider } from "./contexts/AppProvider.tsx";

export const Main = () => {
  const { theme } = useTheme();
  const buttonTextColor = getContrastTextColor(theme.primaryColor);

  return (
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <ConfigProvider
          theme={{
            cssVar: true,
            hashed: false,
            token: {
              colorPrimary: theme.primaryColor,
              colorPrimaryText: buttonTextColor,
            },
          }}
        >
          <StyleProvider hashPriority="high">
            <AppProvider>
              <App />
            </AppProvider>
          </StyleProvider>
        </ConfigProvider>
      </QueryClientProvider>
    </StrictMode>
  );
};

/**
 * TanStack Query client configuration
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

createRoot(document.getElementById("root")!).render(<Main />);
